// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"baae867b","252":"89d7e7af","303":"fd423470","388":"2cad9c8e","412":"f84f36fd","441":"f6d97219","470":"85cbb2e0","507":"e8a538d1","599":"9a14f134"}[chunkId] + ".chunk.js";
};